import React, { useContext, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import NameSubCategoryInput from './components/NameSubCategoryInput';
import CategorySelect from './components/CategorySelect';
import HideSubCategoryCheckbox from './components/HideSubCategoryCheckbox';
import AvailableForRepetitionCheckbox from './components/AvailableForRepetitionCheckbox';
import SendBtn from './components/SendBtn';
import axios from 'axios';
import { Form } from 'antd';
import { ServerErrorTypes } from 'types';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { createSubCategory } from 'backend/subcategories';

const InputFields: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		changeTypeOfModalWindow,
		showErrorModalWithInfo,
		fileId,
		IDCustomer,
		IDRestaurant,
		nameOfSubCategory,
		IDSelectedCategory,
		isHiddenSubCategory,
		isAvailableForRepetition,
		defaultCustomerLanguage,
		translations,
	} = useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ nameOfSubCategory: nameOfSubCategory });
		form.setFieldsValue({ IDSelectedCategory: IDSelectedCategory });
		form.setFieldsValue({ isHiddenSubCategory: isHiddenSubCategory });
		form.setFieldsValue({ isHiddenSubCategory: isAvailableForRepetition });
	}, [nameOfSubCategory, IDSelectedCategory, isHiddenSubCategory, isAvailableForRepetition]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		try {
			changeTypeOfModalWindow(null);
			showLoader();
			await createSubCategory({
				fileId: fileId,
				customerId: IDCustomer ? IDCustomer : '',
				name: nameOfSubCategory,
				categoryId: IDSelectedCategory,
				subCategoryRestaurants: [
					{
						restaurantId: IDRestaurant ? IDRestaurant : '',
						isHidden: isHiddenSubCategory,
						isAvailableForRepetition: isAvailableForRepetition,
					},
				],
				activationCron: null,
				deactivationCron: null,
				translations,
			});
			changeTypeOfModalWindow('success');
		} catch (err) {
			if (
				axios.isAxiosError(err) &&
				err.response?.data.Type === ServerErrorTypes.SUB_CATEGORY_VALIDATION_FAILED
			) {
				showErrorModalWithInfo(err.response.data);
			} else {
				changeTypeOfModalWindow('error');
			}
		} finally {
			hideLoader();
		}
	};

	return (
		<div data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<NameSubCategoryInput />
				<CategorySelect />
				<HideSubCategoryCheckbox />
				<AvailableForRepetitionCheckbox />
				<SendBtn />
			</Form>
		</div>
	);
};

export default InputFields;
